"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CommunicationStages = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _communicationActions = require("../actions/communications/communicationActions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CommunicationStages = exports.CommunicationStages = /*#__PURE__*/function (CommunicationStages) {
  CommunicationStages["FirstStep"] = "FirstStep";
  CommunicationStages["SuccesStep"] = "SuccesStep";
  return CommunicationStages;
}({});
var initialState = {
  step: CommunicationStages.FirstStep,
  isLoading: false,
  apiError: {
    activationLinkExpired: false,
    policyCheckFailed: false,
    unknownError: false,
    policyCheckFailedGp: false,
    policyCheckFailedVk: false
  }
};
var communicationReducer = function communicationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _communicationActions.CommunicationActionType.SUBSCRIBE_SAVE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        apiError: {},
        step: CommunicationStages.SuccesStep
      });
    case _communicationActions.CommunicationActionType.LOAD_COMMUNICATION_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true,
        apiError: {
          activationLinkExpired: false,
          policyCheckFailed: false,
          unknownError: false,
          policyCheckFailedGp: false,
          policyCheckFailedVk: false
        }
      });
    case _communicationActions.CommunicationActionType.SUBSCRIBE_SAVE_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        apiError: action.apiError
      });
    default:
      return state;
  }
};
var _default = exports.default = communicationReducer;